import { ALERTS_STATE } from './constants'
import { IAlertsState } from './state'

export const getAlert = (state: IAlertsState) => state[ALERTS_STATE]
